import React, { Dispatch, SetStateAction, useState } from 'react';
import {
    CommodityItems,
    SalesContractError,
    SalesContractPayload
} from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/SslesContracyInterface';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import { Grid, MenuItem } from '@mui/material';
import NewCustomSelect from '../../../../../newcustomselect/newcustomselect';
import CustomTextField from '../../../../../CustomTextInput';
import {
    contractTypes,
    methodsOfPayments
} from '../../../../../../utils/appconstants';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import PortsAutocomplete from '../../../../../autocompletewithapi/PortsAutocomplete';
import { useGetContainerTypes } from '../../../../../../pages/dashboard/bookings/createbooking/hooks/useGetContainerTypes';
import { shippingLinesInterface } from '../../../../../../customhooks/shippinglines/userShippinglines';
import SalesAddCommodity from '../../../common/SalesAddCommodity';
import SingleCommodityFields from '../../../../../../pages/dashboard/tradedocuments/salescontract/SingleCommodityFields';
import { Commodity } from '../../../../../../interfaces/Commodity';
import AddNewCommodity from '../../../../../../pages/dashboard/tradedocuments/addNewCommodity/AddNewCommodity';
import { SuitUIButton } from '../../../../../SuitUIButton';

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    errors,
    loadingCorporatepartners,
    isLoadingShippingLines,
    setShowAddPartner,
    shippingLines,
    commodityFields,
    updateCommodityField,
    removeCommodityField,
    addCommodityField,
    commoditiesList,
    isLoadingCommodities
}: {
    updateField: (name: string, value: unknown) => void;
    payload: SalesContractPayload;
    corporatePartners: CorporatePartner[];
    errors: SalesContractError;
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    shippingLines: shippingLinesInterface[];
    isLoadingShippingLines: boolean;
    commodityFields: CommodityItems[];
    updateCommodityField: (
        index: number,
        attributeName: keyof CommodityItems,
        attributeValue: CommodityItems[keyof CommodityItems]
    ) => void;
    removeCommodityField: (index: number) => void;
    addCommodityField: () => void;
    commoditiesList: Commodity[];
    isLoadingCommodities: boolean;
}) => {
    const { isLoading, containerTypes } = useGetContainerTypes();
    const [showAddNewCommodity, setShowAddNewCommodity] = useState(false);

    const closeShowAddParty = () => {
        setShowAddNewCommodity(false);
    };
    return (
        <div className='w-full flex flex-col gap-1'>
            <Grid container>
                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] lg:pb-2'>
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                marginTop: 0
                            }}
                        >
                            <Grid item xs={12} md={12} lg={12}>
                                <div className='mt-4'>
                                    <NewCustomSelect
                                        selectValue={String(payload.exporterId)}
                                        required
                                        selectOptions={
                                            corporatePartners as unknown as Record<
                                                string,
                                                unknown
                                            >[]
                                        }
                                        name={'exporterId'}
                                        updateField={(_, value) => {
                                            updateField('exporterId', value);
                                            updateField(
                                                'exporterAddress',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.address
                                            );
                                            updateField(
                                                'exporterName',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.name
                                            );

                                            updateField(
                                                'exporterCountry',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.bankCountry
                                            );
                                        }}
                                        label={'Exporter'}
                                        selectOptionLabel='name'
                                        loading={loadingCorporatepartners}
                                        dropdownRender={() => {
                                            return (
                                                <div className='px-4 border-t border-appcolorgreyfaint'>
                                                    <p
                                                        className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                        onClick={() => {
                                                            setShowAddPartner(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        + Add a New Partner
                                                    </p>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                                <div className='mt-4'>
                                    <CustomTextField
                                        value={payload?.exporterAddress}
                                        error={
                                            errors?.exporterAddress?.length > 0
                                        }
                                        helperText={
                                            errors?.exporterAddress.length > 0
                                                ? errors?.exporterAddress
                                                : undefined
                                        }
                                        id='quotation-exporterAddress'
                                        label='Exporter Address'
                                        name='exporterAddress'
                                        onChange={(e: any) => {
                                            updateField(
                                                'exporterAddress',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] lg:pb-2'>
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                marginTop: 0
                            }}
                        >
                            <Grid item xs={12} md={12} lg={12}>
                                <div className='mt-4'>
                                    <NewCustomSelect
                                        selectValue={payload.customerId}
                                        required
                                        selectOptions={
                                            corporatePartners as unknown as Record<
                                                string,
                                                unknown
                                            >[]
                                        }
                                        name={'customerId'}
                                        updateField={(_, value) => {
                                            updateField('customerId', value);
                                            updateField(
                                                'customerAddress',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.address
                                            );
                                            updateField(
                                                'buyerAddress',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.address
                                            );

                                            updateField(
                                                'customerName',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.name
                                            );
                                            updateField(
                                                'customerBank',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.bankName
                                            );
                                            updateField(
                                                'customerSwiftCode',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.swiftCode
                                            );
                                            updateField(
                                                'customerCountry',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.bankCountry
                                            );
                                            updateField(
                                                'customerBankAccount',
                                                corporatePartners.filter(
                                                    (item: any) =>
                                                        item?.id === value
                                                )[0]?.bankAccountNumber
                                            );
                                        }}
                                        label={'Buyer'}
                                        selectOptionLabel='name'
                                        loading={loadingCorporatepartners}
                                        dropdownRender={() => {
                                            return (
                                                <div className='px-4 border-t border-appcolorgreyfaint'>
                                                    <p
                                                        className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                        onClick={() => {
                                                            setShowAddPartner(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        + Add a New Partner
                                                    </p>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                                <div className='mt-4'>
                                    <CustomTextField
                                        value={payload?.buyerAddress}
                                        error={errors?.buyerAddress?.length > 0}
                                        helperText={
                                            errors?.buyerAddress?.length > 0
                                                ? errors?.buyerAddress
                                                : undefined
                                        }
                                        id='quotation-buyerAddress'
                                        label='Buyer Address'
                                        name='buyerAddress'
                                        onChange={(e: any) => {
                                            updateField(
                                                'buyerAddress',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={4}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <CustomTextField
                            value={payload?.contractNumber}
                            error={errors?.contractNumber.length > 0}
                            helperText={
                                errors?.contractNumber.length > 0
                                    ? errors?.contractNumber
                                    : undefined
                            }
                            required
                            id='quotation-contractNumber'
                            label='Contract Number'
                            name='contractNumber'
                            onChange={(e: any) => {
                                updateField('contractNumber', e.target.value);
                            }}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={4}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <CustomTextField
                            value={payload?.contractType}
                            select
                            error={errors?.contractType.length > 0}
                            helperText={
                                errors?.contractType.length > 0
                                    ? errors?.contractType
                                    : undefined
                            }
                            required
                            id='quotation-methodOfDispatch'
                            label='Contract Type'
                            name='contractType'
                            onChange={(e: any) => {
                                updateField('contractType', e.target.value);
                                updateField(
                                    'salesContractType',
                                    e.target.value
                                );
                            }}
                        >
                            {contractTypes.map((item, index) => (
                                <MenuItem
                                    value={item}
                                    key={`medthodsOfDispatch-${item}-${index}`}
                                >
                                    {item}
                                </MenuItem>
                            ))}
                        </CustomTextField>
                    </div>
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] lg:pb-2'>
                        <div className='mt-4 lg:mt-[.9rem]'>
                            <Customdatepicker
                                id='quotation-shippingDeadline'
                                label='Shipping Deadline'
                                name='shippingDeadline'
                                updateField={updateField}
                                error={errors?.shippingDeadline.length > 0}
                                helperText={
                                    errors?.shippingDeadline.length > 0
                                        ? errors?.shippingDeadline
                                        : undefined
                                }
                                value={
                                    payload?.shippingDeadline !== undefined
                                        ? payload?.shippingDeadline
                                        : null
                                }
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <PortsAutocomplete
                            errorCondition={errors?.portOfLoadingId?.length > 0}
                            helperText={
                                errors?.portOfLoadingId?.length > 0
                                    ? errors?.portOfLoadingId
                                    : undefined
                            }
                            id='quotation-portOfLoading'
                            label='Port of Loading'
                            name='portOfLoadingId'
                            updateField={updateField}
                            nameValue='portOfLoadingValue'
                            value={payload.portOfLoadingValue}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={4}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <NewCustomSelect
                            required
                            selectValue={payload.containerType}
                            selectOptions={
                                containerTypes as unknown as Record<
                                    string,
                                    string | number
                                >[]
                            }
                            name={'containerType'}
                            updateField={(_, value) => {
                                updateField('containerType', value);
                            }}
                            label='Container Type'
                            selectOptionLabel='shortDescription'
                            loading={isLoading}
                            alternativeValue='shortDescription'
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={4}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <CustomTextField
                            select
                            error={errors?.paymentTerms.length > 0}
                            helperText={
                                errors?.paymentTerms.length > 0
                                    ? errors?.paymentTerms
                                    : undefined
                            }
                            required
                            id='salesContract-termsOfPayment'
                            label='Payment Term'
                            name='paymentTerms'
                            value={payload?.paymentTerms}
                            onChange={(e: any) => {
                                updateField('paymentTerms', e.target.value);
                            }}
                        >
                            {methodsOfPayments.map((item, index) => (
                                <MenuItem
                                    value={item}
                                    key={`paymentTerms-${item}-${index}`}
                                >
                                    {item}
                                </MenuItem>
                            ))}
                        </CustomTextField>
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <PortsAutocomplete
                            errorCondition={
                                errors?.portOfDischargeId.length > 0
                            }
                            helperText={
                                errors?.portOfDischargeId.length > 0
                                    ? errors?.portOfDischargeId
                                    : undefined
                            }
                            id='quotation-portOfDischargeId'
                            label='Port of Discharge'
                            name='portOfDischargeId'
                            updateField={updateField}
                            nameValue='portOfDischargeValue'
                            value={payload.portOfDischargeValue}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <NewCustomSelect
                            selectValue={payload.shippingLineId}
                            required
                            selectOptions={
                                shippingLines as unknown as Record<
                                    string,
                                    unknown
                                >[]
                            }
                            name={'shippingLineId'}
                            updateField={(_, value) => {
                                updateField('shippingLineId', value);
                                updateField(
                                    'shippingLineValue',
                                    shippingLines.filter(
                                        (item: any) => item?.id === value
                                    )[0]?.name
                                );
                            }}
                            label={'Shipping Line'}
                            selectOptionLabel='name'
                            loading={isLoadingShippingLines}
                        />
                    </div>
                </Grid>
                <div className='lg:hidden border border-appcolorgreyfaint border-dashed w-full mt-6' />

                {commodityFields.map((item: CommodityItems, index) => (
                    <>
                        <SingleCommodityFields
                            item={item}
                            key={item.id}
                            index={index}
                            id={item.id}
                            updateQuoteField={updateCommodityField}
                            price={item.price ?? 0}
                            qty={item.qty ?? 0}
                            errors={errors}
                            removeQuoteField={removeCommodityField}
                            {...{
                                commoditiesList,
                                isLoadingCommodities,
                                setShowAddNewCommodity
                            }}
                        />
                        {index < commodityFields?.length - 1 && (
                            <div className='lg:hidden border border-appcolorgreyfaint border-dashed w-full mt-4' />
                        )}
                    </>
                ))}

                <Grid item xs={12} md={12} lg={12}>
                    <SuitUIButton
                        text='Add Commodity'
                        onClick={addCommodityField}
                        invert
                        fullWidth
                        style='px-[0.92rem] mt-4 text-[#00516A] font-medium text-sm leading-[20px] bg-[#E5F3F7] lg:hidden'
                    />
                    <div className='hidden lg:block lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1rem] lg:pb-2 mt-4 lg:mt-0'>
                        <SalesAddCommodity
                            {...{
                                addCommodityField
                            }}
                        />
                    </div>
                </Grid>
            </Grid>

            {showAddNewCommodity ? (
                <AddNewCommodity
                    closeDrawer={closeShowAddParty}
                    showDrawer={showAddNewCommodity}
                />
            ) : null}
        </div>
    );
};

export default StepOne;
